export const CREATE_PUBLICITY_NEW = `mutation ($requestPublicity: JSON, $logo: Upload) {
createPublicity(requestPublicity: $requestPublicity, logo: $logo) {
    message
        publicity {
            id
            descriptionPublicity
            commercialName
            link
            startDate
            finishDate
            logo
            id_category
        }
    }
}`;

export const SEND_PUBLICITY_TECH = ` mutation ($id_p:String,$id_a:String) {
    sendPublicity(id_p:$id_p,id_a:$id_a) {
        message
        state
    } 
}`;

export const UPDATE_PUBLICITY = `
    mutation ($id:ID! ,$requestPublicity:JSON ,$logo:Upload){
        updatePublicity(id:$id,requestPublicity:$requestPublicity,logo:$logo){
            message
            publicity {
                id
                descriptionPublicity
                commercialName
                link
                startDate
                finishDate
                logo
                id_category
            }
        }
    }
`;
